import { deviceStorage } from '@/shared/services/storage/device-storage';

/**
 * Rangement des jetons.
 *
 * Le stockage lui-meme vit dans `device-storage` (trousseau iOS, Keystore
 * Android, `localStorage` sur le web de développement) : ici on ne décide que
 * des clés et de la forme du couple de jetons.
 */
const ACCESS_KEY = 'bul.access-token';
const REFRESH_KEY = 'bul.refresh-token';

export interface StoredTokens {
  accessToken: string;
  refreshToken: string;
}

export const tokenStorage = {
  async load(): Promise<StoredTokens | null> {
    const [accessToken, refreshToken] = await Promise.all([
      deviceStorage.read(ACCESS_KEY),
      deviceStorage.read(REFRESH_KEY),
    ]);
    if (!accessToken || !refreshToken) {
      return null;
    }
    return { accessToken, refreshToken };
  },

  async save(tokens: StoredTokens): Promise<void> {
    await Promise.all([
      deviceStorage.write(ACCESS_KEY, tokens.accessToken),
      deviceStorage.write(REFRESH_KEY, tokens.refreshToken),
    ]);
  },

  async clear(): Promise<void> {
    await Promise.all([deviceStorage.remove(ACCESS_KEY), deviceStorage.remove(REFRESH_KEY)]);
  },
};
